import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import Table from "@/components/elements/Table/Table";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import imgnotavailableImg from '@/assets/images/products/imgnotavailable.png';

// Animation variants
const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const VistaPumpcare = () => {
  return (
    <div className="2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar
        title="Vista Pump Care"
        subTitle="(Ready To Use Powder For Lubrication Of Concrete Pump & Pumpline)"
      />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct alt="Vista Pump Care"
          title="Description"
          imageUrl={imgnotavailableImg}
          content="Vista Pump Care is a dry polymer based powder concrete pump primer, easily miscible in water and is 
                    available in pre-measured pack. It is uniquely formulated to provide the concrete pumper with a cost 
                    effective method for improving the pump ability of hard to pump and/or harsh concrete and grout mixes."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Uses">
          <Paragraph content="Vista Pump Care contains water thickeners and lubricating agents. As it goes through the pipes, 
                                leaves a coat of water and lubricating agents and effectively wets all surfaces. So when concrete 
                                comes behind the Vista Pump Care, it does not loose water. The phenomenon of friction when the 
                                concrete passes through long pipelines get reduced and the lubrication effect of the compound 
                                makes concrete pass smoothly without chocking of the pump and pump line. It does not contain 
                                bentonite, chloride, nitrates, nitrites or other potentially corrosive materials and is compatible with all 
                                standard concrete admixtures." />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <CustomLists
            items={[
              [
                "Increases ease and range of pump ability.",
                "Decreases wear on equipment.",
                "Decreases horsepower required for pumping.",
                "Easily introduced into pumping equipment. Ready to use only water to be used.",
              ],
              [
                "Reduces friction and line pressure.",
                " Improves motility and consolidation.",
                " Minimizes slump and air loss through pump lines.",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
          <Table
            items={{
              headings: [],
              rows: [
                ["Aspect", " White Granular Powder"],
                ["Chloride Content", "Nil - No added chloride"],
                ["Safety Standards", "Non toxic and non inflammable"],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Packing">
          <Paragraph content="200 gm pouch pack." />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaPumpcare;
